/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function() {
  /**
   * Enhanced Search Bar & Predictive Search Controller
   */
  initEnhancedSearch();
});

function initEnhancedSearch() {
  var searchForms = document.querySelectorAll('.search-bar');
  if (!searchForms.length) return;

  searchForms.forEach(function(form) {
    var input = form.querySelector('.search-bar__input');
    var inner = form.querySelector('.search-bar__inner');
    var preDefault = form.querySelector('.search-popup__pre-default');
    var resultsContainer = form.querySelector('.search-bar__results');
    var resultsInner = form.querySelector('.search-bar__results-inner');
    var clearBtn = form.querySelector('[data-action="clear-input"]');
    var filterSelect = form.querySelector('#search-product-type');
    var activeFilterLabel = form.querySelector('.search-bar__filter-active');

    if (!input || !inner) return;

    var currentQuery = '';
    var searchTimer = null;
    var abortController = null;

    function openSearch() {
      form.classList.add('is-expanded', 'is-focused');
      inner.classList.add('is-open');

      if (input.value.trim() === '') {
        if (preDefault) preDefault.setAttribute('aria-hidden', 'false');
        if (resultsContainer) resultsContainer.setAttribute('aria-hidden', 'true');
      } else {
        if (preDefault) preDefault.setAttribute('aria-hidden', 'true');
        if (resultsContainer) resultsContainer.setAttribute('aria-hidden', 'false');
      }
    }

    function closeSearch() {
      form.classList.remove('is-expanded', 'is-focused', 'is-loading');
      inner.classList.remove('is-open');
      if (preDefault) preDefault.setAttribute('aria-hidden', 'true');
      if (resultsContainer) resultsContainer.setAttribute('aria-hidden', 'true');
    }

    function executeSearch(query) {
      query = query.trim();
      currentQuery = query;

      if (!query) {
        form.classList.remove('is-loading');
        if (preDefault) preDefault.setAttribute('aria-hidden', 'false');
        if (resultsContainer) resultsContainer.setAttribute('aria-hidden', 'true');
        return;
      }

      if (preDefault) preDefault.setAttribute('aria-hidden', 'true');
      if (resultsContainer) resultsContainer.setAttribute('aria-hidden', 'false');
      form.classList.add('is-loading');

      if (abortController) {
        abortController.abort();
      }
      abortController = new AbortController();

      var productType = filterSelect ? filterSelect.value : '';
      var predictiveUrl = (window.routes && window.routes.predictive_search_url) ? window.routes.predictive_search_url : '/search/suggest';
      var searchAjaxUrl = (window.routes && window.routes.searchUrl) ? window.routes.searchUrl : '/search';

      // First try predictive-search section
      var url = predictiveUrl + '?section_id=predictive-search&q=' + encodeURIComponent(query) + '&resources[type]=product,collection,query&resources[options][unavailable_products]=last';

      fetch(url, { signal: abortController.signal })
        .then(function(res) {
          if (!res.ok) throw new Error('Status ' + res.status);
          return res.text();
        })
        .then(function(html) {
          if (currentQuery !== query) return;
          form.classList.remove('is-loading');

          var temp = document.createElement('div');
          temp.innerHTML = html;
          var content = temp.querySelector('.predictive-search-ajax-content') || temp.querySelector('#shopify-section-predictive-search') || temp;

          if (resultsInner) {
            resultsInner.innerHTML = content.innerHTML;
          }
        })
        .catch(function(err) {
          if (err.name === 'AbortError') return;

          // Fallback to search-ajax section
          var fallbackUrl = searchAjaxUrl + '?section_id=search-ajax&q=' + encodeURIComponent(query) + '&options[prefix]=last&type=product';
          fetch(fallbackUrl)
            .then(function(r) { return r.text(); })
            .then(function(html) {
              if (currentQuery !== query) return;
              form.classList.remove('is-loading');
              var temp = document.createElement('div');
              temp.innerHTML = html;
              var content = temp.querySelector('.search-ajax') || temp;
              if (resultsInner) {
                resultsInner.innerHTML = content.innerHTML;
              }
            })
            .catch(function() {
              form.classList.remove('is-loading');
            });
        });
    }

    // Input events
    input.addEventListener('focus', function() {
      openSearch();
    });

    input.addEventListener('click', function() {
      openSearch();
    });

    input.addEventListener('input', function() {
      var val = input.value;
      if (val !== '') {
        input.classList.add('is-filled');
      } else {
        input.classList.remove('is-filled');
      }

      clearTimeout(searchTimer);
      searchTimer = setTimeout(function() {
        executeSearch(val);
      }, 200);
    });

    input.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeSearch();
        input.blur();
      }
    });

    // Clear button
    if (clearBtn) {
      clearBtn.addEventListener('click', function(e) {
        e.preventDefault();
        input.value = '';
        input.classList.remove('is-filled');
        input.focus();
        executeSearch('');
      });
    }

    // Category filter change
    if (filterSelect) {
      filterSelect.addEventListener('change', function() {
        if (activeFilterLabel) {
          activeFilterLabel.textContent = filterSelect.options[filterSelect.selectedIndex].text;
        }
        if (input.value.trim() !== '') {
          executeSearch(input.value);
        }
      });
    }

    // Click on suggestion / popular search terms
    form.addEventListener('click', function(e) {
      var termBtn = e.target.closest('[data-search-term]');
      if (termBtn) {
        e.preventDefault();
        var term = termBtn.getAttribute('data-search-term');
        if (term) {
          input.value = term;
          input.classList.add('is-filled');
          input.focus();
          executeSearch(term);
        }
        return;
      }

      var viewAllBtn = e.target.closest('.search-popup__view-all-btn') || e.target.closest('.search-popup__footer');
      if (viewAllBtn) {
        e.preventDefault();
        var searchUrl = (window.routes && window.routes.searchUrl) ? window.routes.searchUrl : '/search';
        window.location.href = searchUrl + '?q=' + encodeURIComponent(input.value.trim()) + '&type=product&options[prefix]=last';
      }
    });
  });

  // Close search when clicking outside
  document.addEventListener('click', function(e) {
    var insideSearch = e.target.closest('.header__search-bar-wrapper') || e.target.closest('.search-bar') || e.target.closest('[data-action="toggle-search"]');
    if (!insideSearch) {
      document.querySelectorAll('.search-bar.is-expanded, .search-bar__inner.is-open').forEach(function(el) {
        var form = el.closest('.search-bar') || el;
        form.classList.remove('is-expanded', 'is-focused', 'is-loading');
        var inner = form.querySelector('.search-bar__inner');
        if (inner) inner.classList.remove('is-open');
        var preDefault = form.querySelector('.search-popup__pre-default');
        if (preDefault) preDefault.setAttribute('aria-hidden', 'true');
        var results = form.querySelector('.search-bar__results');
        if (results) results.setAttribute('aria-hidden', 'true');
      });
    }
  });
}

